import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import "../../style.css";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";
import { ChartBar } from "./chart";
import { TableList } from "./table";

interface Info {
  type: string
}
export interface Routes {
  data: {
    tma: {
      region?: string,
      tma_today: number,
      tma_last_4_weekdays: number,
      tma_last_28_days: number
    }[],
    count: number,
    total: {
      tma_today: number,
      tma_last_4_weekdays: number,
      tma_last_28_days: number
    }
  }
}

export const RoutesAverageStayOnInterval = ({type}: Info) => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    tma: [
      {
        region: "", 
        tma_today: 0, 
        tma_last_4_weekdays: 0, 
        tma_last_28_days: 0
      }
    ],
    count: 0,
    total: {
      tma_today: 0, 
      tma_last_4_weekdays: 0, 
      tma_last_28_days: 0
    }
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/routes/avarege-stay-on-interval?graphic_id=chartRoutesFinishedOnInterval&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/routes/avarege-stay-on-interval?graphic_id=chartRoutesFinishedOnInterval&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }
RoutesAverageStayOnInterval
  return completeRequisition && !reloadComponent ? (
    type === 'chart' ? (
      <div id="chart-routes-average-stay-on-interval" className="h100">
        <ChartBar data={routes} />
      </div>
    ) : (
      <div id="table-routes-average-stay-on-interval" className="h100">
        <TableList data={routes} />
      </div>
    )
  ) : (
    <LoadingGraphics/>
  );
};
